document.addEventListener('DOMContentLoaded', function () {
  // Modal popup functionality
  const openPopupButton = document.getElementById('engrave-model');
  const closePopupButtons = [
    document.getElementById('close-popup'), 
    document.getElementById('mobile-close')
  ];
  const popupOverlay = document.getElementById('engrave-option-model');
  
  if (openPopupButton && closePopupButtons.length && popupOverlay) {
    openPopupButton.addEventListener('click', () => {
      popupOverlay.classList.remove('hidden');
      document.body.classList.add('engrave-model-open');
    });
    
    closePopupButtons.forEach(button => {
      if (button) button.addEventListener('click', () => {
        popupOverlay.classList.add('hidden');
        document.body.classList.remove('engrave-model-open'); 
      });
    });   
    
    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) {
        popupOverlay.classList.add('hidden');
        document.body.classList.remove('engrave-model-open'); 
      }
    });
  }

  // Engraving Toggle Functionality
  document.querySelectorAll('.engraving_type_selection').forEach(selection => {
    selection.addEventListener('change', function() {
      const toggleDiv = this.closest('.engrave_selection').nextElementSibling;
      if (toggleDiv) {
        toggleDiv.style.display = this.value === 'Engraving' ? 'block' : 'none';
      }
    });
  });

  // Preview Text Functionality
  document.querySelectorAll('.ff_select').forEach(selectDropdown => {
    if (!selectDropdown) return;
    
    let firstFont = '';
    for (let i = 0; i < selectDropdown.options.length; i++) {
      const opt = selectDropdown.options[i];
      if (opt && opt.value && opt.value.trim()) {
        firstFont = opt.value;
        break;
      }
    }
    
    // Extract index safely
    const idParts = selectDropdown.id ? selectDropdown.id.split('_') : [];
    const index = idParts.length >= 4 ? idParts[3] : '';
    const previewTextElement = index ? document.getElementById('engraving-preview-text-' + index) : null;
    
    if (firstFont && previewTextElement) {
      previewTextElement.style.fontFamily = firstFont;
    }
    
    selectDropdown.addEventListener('change', function() {
      if (previewTextElement && this.value) {
        previewTextElement.style.fontFamily = this.value;
      }
    });
  });

  document.querySelectorAll('.engrave_user_text').forEach(inputField => {
    if (!inputField || !inputField.id) return;
    
    inputField.addEventListener('input', function () {
      const idParts = this.id.split('_');
      if (idParts.length < 2) return;
      
      const index = idParts[1];
      const previewTextElement = document.getElementById('engraving-preview-text-' + index);
  
      if (previewTextElement) {
        previewTextElement.textContent = this.value.trim() || 'Your text will appear here...';
      }
  
      // Real-time validation for enabling/disabling Save button
      const autify_engraveSaveBtn = document.querySelector(".autify-engrave-add-btn");
      if (autify_engraveSaveBtn) {
        const allFilled = [...document.querySelectorAll('.engrave_user_text')]
          .every(input => input.value && input.value.trim().length > 0);
    
        autify_engraveSaveBtn.disabled = !allFilled;
      }
    });
  });

  // Icons Dropdown Configuration
  const ICON_PATHS = {
    "A": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/a.png",
    "B": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/b.png",
    "C": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/c.png",
    "D": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/d.png",
    "E": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/e.png",
    "F": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/f.png",
    "G": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/g.png",
    "H": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/h.png",
    "I": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/i.png",
    "J": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/j.png",
    "K": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/k.png",
    "L": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/l.png",
    "M": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/m.png",  
    "N": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/n.png",
    "O": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/o.png",
    "P": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/p.png",
    "Q": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/q.png",
    "R": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/r.png",
    "S": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/s.png",
    "T": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/t.png",
    "U": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/u.png",
    "V": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/k.png",
    "W": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/w.png",
    "X": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/x.png",
    "Y": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/y.png",
    "Z": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/z.png",
    "Flower": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/flower.png",
    "Heart": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/heart.png",
    "Ballet Shoes": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/ballet-shoes.png",
    "Lucky Clover": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/lucky-clover.png",
    "Music Note": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/music-note.png",
    "Star": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/star_3.png",
    "Horseshoe": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/horseshoe.png",
    "Bunny": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/bunny.png",
    "Butterfly": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/butterfly.png",
    "Pony": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/pony.png",
    "Moon": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/moon.png",
    "Hamster Mouse": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/hamster-mouse.png",
    "Baby Feet": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/baby-feet.png",
    "Puppy": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/puppy.png",
    "Kitten": "https://cdn.shopify.com/s/files/1/0642/2904/8494/files/kitten.png",
  };

  // Initialize custom dropdowns
  document.querySelectorAll('.autify-custom-dropdown').forEach(dropdown => {
    if (!dropdown) return;
    
    const selected = dropdown.querySelector('.dropdown-selected');
    const optionsContainer = dropdown.querySelector('.dropdown-options');
    if (!selected || !optionsContainer) return;
    
    const options = optionsContainer.querySelectorAll('.dropdown-option');
    const hiddenInput = dropdown.nextElementSibling;

    // Set images dynamically from ICON_PATHS
    options.forEach(option => {
      if (!option) return;
      const value = option.getAttribute('data-value');
      if (value && ICON_PATHS[value]) {
        const imgElement = option.querySelector('img');
        if (imgElement) imgElement.src = ICON_PATHS[value];
      }
    });

    // Toggle the options dropdown
    selected.addEventListener('click', () => {
      optionsContainer.style.display = optionsContainer.style.display === 'block' ? 'none' : 'block';
    });

    // Handle option selection
    options.forEach(option => {
      if (!option) return;
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value');
        const text = option.textContent ? option.textContent.trim() : '';
        const imgElement = option.querySelector('img');
        
        if (value && text && imgElement && imgElement.src) {
          selected.innerHTML = `<img src="${imgElement.src}" alt="${value}" style="width: 20px; height: 20px; margin-right: 10px;"> ${text}`;
          selected.setAttribute('data-icon-value', value);
          optionsContainer.style.display = 'none';

          if (hiddenInput && hiddenInput.tagName === 'INPUT') {
            hiddenInput.value = value;
          }
          
          // Trigger data gathering after selection
          if (typeof gatherEngravingData === 'function') {
            gatherEngravingData();
          }
        }
      });
    });
  });

  // Close any open dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.autify-custom-dropdown').forEach(dropdown => {
      if (dropdown && !dropdown.contains(e.target)) {
        const optionsContainer = dropdown.querySelector('.dropdown-options');
        if (optionsContainer) optionsContainer.style.display = 'none';
      }
    });
  });

  // Form data handling functions
  const form = document.querySelector('.autify-engmodal-form');
  const autify_engraveSaveBtn = document.querySelector(".autify-engrave-add-btn");
  
  function removeHiddenInput(id) {
    const input = document.getElementById(id);
    if (input) input.remove();
  }

  function createHiddenInput(id, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.id = id;
    input.name = id; // Adding name attribute for form submission
    input.value = value;
    if (form) form.appendChild(input);
  }

  function gatherEngravingData() {
    const engravingSets = document.querySelectorAll('.engrave_set');
    let allFieldsFilled = true;

    // Remove existing hidden inputs
    document.querySelectorAll('input[id^="engravedata_"]').forEach(input => input.remove());

    engravingSets.forEach((set, index) => {
      if (!set) return;
      
      // Fetch values
      const locationElement = set.querySelector('.engrave_set_title');
      const location = locationElement ? locationElement.innerText : '';
      
      const typeSelection = set.querySelector('.engraving_type_selection');
      const engravingType = typeSelection ? typeSelection.value : '';
      
      const engraveOptionToggle = set.querySelector('.engrave_option_toggle');
      const engraveOptionDataValue = engraveOptionToggle ? engraveOptionToggle.getAttribute('data-value') : '';

      // Add location and type
      createHiddenInput(`engravedata_location_${index}`, location);
      createHiddenInput(`engravedata_type_${index}`, engravingType === 'Engraving' ? 'Engraving' : 'No Engraving');

      // Handle "No Engraving" case
      if (engravingType !== 'Engraving') {
        ['mode', 'font', 'icon', 'userinput'].forEach(field => 
          removeHiddenInput(`engravedata_${field}_${index}`));
        return;
      }

      // Process based on engraving type (icon or text)
      if (engraveOptionDataValue === 'text') {
        createHiddenInput(`engravedata_mode_${index}`, 'text');
        
        const fontSelect = set.querySelector('.ff_select');
        const fontValue = fontSelect ? fontSelect.value : '';
        
        const userInputField = set.querySelector('.engrave_user_text');
        const userInput = userInputField ? userInputField.value : '';
        
        createHiddenInput(`engravedata_font_${index}`, fontValue);
        createHiddenInput(`engravedata_userinput_${index}`, userInput);
        
        if (!fontValue || !userInput) allFieldsFilled = false;
      } else if (engraveOptionDataValue === 'icon') {
        createHiddenInput(`engravedata_mode_${index}`, 'icon');
        
        const selectedIcon = set.querySelector('.autify-custom-dropdown .dropdown-selected');
        const iconValue = selectedIcon ? selectedIcon.getAttribute('data-icon-value') : '';
        createHiddenInput(`engravedata_icon_${index}`, iconValue || '');
        
        if (!iconValue) allFieldsFilled = false;
      }

      // Check required fields
      if (!location || !engravingType || (engravingType === 'Engraving' && !engraveOptionDataValue)) {
        allFieldsFilled = false;
      }
    });

    // Enable/disable save button
    if (autify_engraveSaveBtn) {
      autify_engraveSaveBtn.disabled = !allFieldsFilled;
    }
  }

  // Watch for changes in custom dropdowns
  function observeDropdownChanges() {
    const dropdowns = document.querySelectorAll('.autify-custom-dropdown .dropdown-selected');
    dropdowns.forEach(dropdown => {
      if (!dropdown) return;
      const observer = new MutationObserver(gatherEngravingData);
      observer.observe(dropdown, { 
        attributes: true, 
        attributeFilter: ['data-icon-value'] 
      });
    });
  }

  // Add event listeners for form changes
  if (form) {
    form.addEventListener('change', gatherEngravingData);
  }

  // Disable save button by default
  if (autify_engraveSaveBtn) {
    autify_engraveSaveBtn.disabled = true;
  }

  // Initialize data gathering and dropdown observation
  gatherEngravingData();
  observeDropdownChanges();

  function handleCartSubmission() {
    console.log('handleCartSubmission called');
  
    const addToCartButton = document.querySelector('.product-form__submit');
    const productForm = addToCartButton?.closest('form');
  
    if (!productForm) {
      console.error('Product form not found.');
      return;
    }
  
    const productVariantIdElement = productForm.querySelector('.product-variant-id');
    const productVariantId = productVariantIdElement?.value;
  
    if (!productVariantId) {
      console.error('Product variant ID not found.');
      return;
    }
  
    const hiddenInputs = document.querySelectorAll('input[id^="engravedata_"]');
    const properties = {};
    let allFieldsFilled = true;
  
    hiddenInputs.forEach(input => {
      if (!input || !input.id) return;
  
      const inputValue = input.value.trim();
      const inputId = input.id;
      const indexMatch = inputId.match(/_(\d+)$/);
  
      if (indexMatch && indexMatch[1]) {
        const index = indexMatch[1];
        if (inputId.includes('mode')) return;
  
        const propertyKey = `Engraving ${parseInt(index) + 1}`;
        if (!properties[propertyKey]) properties[propertyKey] = '';
  
        let engravingInfo = '';
  
        if (inputId.includes('location')) {
          engravingInfo = `Location: ${inputValue}`;
        } else if (inputId.includes('type')) {
          engravingInfo = `Type: ${inputValue}`;
        } else if (inputId.includes('font')) {
          engravingInfo = `Font: ${inputValue}`;
        } else if (inputId.includes('userinput')) {
          engravingInfo = `Text: ${inputValue}`;
        } else if (inputId.includes('icon')) {
          engravingInfo = `Icon: ${inputValue}`;
        }
  
        if (engravingInfo) {
          properties[propertyKey] += properties[propertyKey] ? ', ' + engravingInfo : engravingInfo;
        }
  
        if (!inputValue) allFieldsFilled = false;
      }
    });
  
    // Remove any previous property inputs before appending new ones
    const existingPropertyInputs = productForm.querySelectorAll('input[name^="properties["]');
    existingPropertyInputs.forEach(el => el.remove());
  
    // Append the engraving data as hidden inputs to the form
    if (!allFieldsFilled) {
      const noEngraveInput = document.createElement('input');
      noEngraveInput.type = 'hidden';
      noEngraveInput.name = 'properties[Engraving]';
      noEngraveInput.value = 'No Engraving Selected';
      productForm.appendChild(noEngraveInput);
    } else {
      Object.entries(properties).forEach(([key, value]) => {
        const propInput = document.createElement('input');
        propInput.type = 'hidden';
        propInput.name = `properties[${key}]`;
        propInput.value = value;
        productForm.appendChild(propInput);
      });
    }
  
    // Trigger form submission
    const hiddenSubmit = document.createElement('button');
    hiddenSubmit.type = 'submit';
    hiddenSubmit.style.display = 'none';
    productForm.appendChild(hiddenSubmit);
    hiddenSubmit.click();
  
    console.log('Adding item to cart with engraving properties');

    }

  //Reset Engraving Form
  function resetAllEngravingForms() {
    const form = document.querySelector('.autify-engmodal-form');
    if (!form) return;
  
    // Get all hidden inputs inside the form
    const inputs = form.querySelectorAll('input[type="hidden"]');
  
    // Create a map of sets by index (e.g. 0, 1, 2...)
    const indexes = new Set();
  
    inputs.forEach(input => {
      const match = input.name.match(/_(\d+)$/);
      if (match) indexes.add(match[1]);
    });
  
    indexes.forEach(index => {
      // Reset hidden fields
      const type = form.querySelector(`#engravedata_type_${index}`);
      const mode = form.querySelector(`#engravedata_mode_${index}`);
      const font = form.querySelector(`#engravedata_font_${index}`);
      const userinput = form.querySelector(`#engravedata_userinput_${index}`);
      const icon = form.querySelector(`#engravedata_icon_${index}`);
  
      if (type) type.value = 'No Engraving';
      if (mode) mode.value = '';
      if (font) font.value = '';
      if (userinput) userinput.value = '';
      if (icon) icon.value = '';
  
      // Reset visible select and input (if exist)
      const selectFont = form.querySelector(`#font_family_select_${index}`);
      const textInput = form.querySelector(`#usertext_${index}`);
      const preview = form.querySelector(`#engraving-preview-text-${index}`);
      const engravingSelect = form.querySelectorAll('.engraving_type_selection')[index];
  
      if (selectFont) selectFont.value = '';
      if (textInput) textInput.value = '';
      if (preview) {
        preview.textContent = 'Your text will appear here...';
        preview.style.fontFamily = 'Arial'; // or reset as per your default
      }
      if (engravingSelect) {
        engravingSelect.value = 'No Engraving';
        engravingSelect.dispatchEvent(new Event('change')); // trigger any attached change listeners
      }
    });

    console.log("Engraving form reseted successfully!")
  }
  
  
  // Button click to trigger the engraving submission
  const submissionButton = document.getElementById("engrave-model-submission");
  if (submissionButton) {
    submissionButton.addEventListener("click", function () {
      handleCartSubmission();
      if (typeof popupOverlay !== 'undefined') {
        popupOverlay.classList.add('hidden');
        document.body.classList.remove('engrave-model-open'); 
      }
      resetAllEngravingForms();
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Function to scroll model-body to bottom smoothly
  function scrollModalToBottom() {
    const modelBody = document.querySelector('.engrave-option-model .model-body');
    if (modelBody) {
      setTimeout(function() {
        modelBody.scrollTo({
          top: modelBody.scrollHeight,
          behavior: 'smooth'
        });
      }, 100); // Small delay to ensure content is fully rendered
    }
  }
  
  // Call the function when modal becomes visible
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (document.querySelector('.engrave-option-model:not(.hidden)')) {
        scrollModalToBottom();
      }
    });
  });
  
  // Start observing the entire document for changes
  observer.observe(document.body, { 
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  
  // Also trigger when any "add engraving" button is clicked
  document.addEventListener('click', function(event) {
    if (event.target.closest('[id^="engrave-option"], .engraving-trigger')) {
      setTimeout(scrollModalToBottom, 100);
    }
  });
});